import { useIsMobileNativeShareCapable } from './shared/useIsMobileNativeShareCapable';

export function useMobileNativeShareAvailable(): boolean {
	return useIsMobileNativeShareCapable();
}
